import type { LanguageCode } from '../config/locale';

const SUPPORTED: ReadonlySet<string> = new Set<LanguageCode>([
  'en',
  'fr',
  'es',
  'de',
]);

export function normalizeContentLocale(
  raw: string | null | undefined,
): LanguageCode {
  const x = String(raw || 'en').toLowerCase().split('-')[0];
  return (SUPPORTED.has(x) ? x : 'en') as LanguageCode;
}

/**
 * Adds or removes `locale` on an absolute API URL so dynamic English copy in the DB
 * can be overlaid with `content_translations` for non-English storefront languages.
 */
export function applyContentLocaleToUrl(
  absoluteApiUrl: string,
  locale: string | undefined | null,
): string {
  const lng = normalizeContentLocale(locale);
  const u = new URL(absoluteApiUrl);
  if (lng === 'en') u.searchParams.delete('locale');
  else u.searchParams.set('locale', lng);
  return u.toString();
}
